export default __webpack_public_path__ + "static/assets/no_labs.2abf17a3.png";